export enum FolderSection {
    Usage,
    Repertoire,
    Payment,
}